<template>
  <div class="bill-details" ref="container">
    <div class="nav acea-row">

      <div class="item" :class="types == index ? 'on' : ''" @click="toCommissionList(index)" v-for="(item, index) in moneyType" :key="index">{{item}}</div>
    </div>

    <div class="my-promotion">
      <div class="header"  style="background-color: #ec5d59 !important;">
        <div class="name acea-row row-center-wrapper">
          <div>{{account_name}}</div>
        </div>
        <div class="num">{{money || 0}}</div>

      </div>
    </div>
    <div class="my-account" v-if="recharge_status==1 || recharge_list_status==1 || extract_status==1 || extract_list_status==1 || transfer_status==1 || transfer_list_status==1 || change_status==1 || change_list_status==1 || types=='password_money'">
      <div class="wrapper">
        <div class="nav acea-row row-middle">
<!--          <router-link class="item" :to="'/user/bill_growth'" v-if="types=='password_money'">
            <div class="pictrue"><img src="@assets/images/record2.png" /></div>
            <div>释放记录</div>
          </router-link>-->

          <router-link class="item" :to="'/user/recharge'" v-if="recharge_status==1">
            <div class="pictrue"><img src="@assets/images/record2.png" /></div>
            <div>充值</div>
          </router-link>
          <router-link class="item" :to="'/user/recharge_list'" v-if="recharge_list_status==1">
            <div class="pictrue"><img src="@assets/images/record2.png" /></div>
            <div>充值记录</div>
          </router-link>

          <router-link class="item" :to="'/user/user_cash/'+types"  v-if="extract_status==1">
            <div class="pictrue"><img src="@assets/images/record3.png" /></div>
            <div>提现</div>
          </router-link>
          <router-link class="item" :to="'/user/cashrecord'" v-if="extract_list_status==1">
            <div class="pictrue"><img src="@assets/images/record3.png" /></div>
            <div>提现记录</div>
          </router-link>

          <router-link class="item" :to="'/user/transfer/'+types"  v-if="transfer_status==1">
            <div class="pictrue"><img src="@assets/images/record4.png" /></div>
            <div>转账</div>
          </router-link>
          <router-link class="item" :to="'/user/transfercord'" v-if="transfer_list_status==1">
            <div class="pictrue"><img src="@assets/images/record4.png" /></div>
            <div>转账记录</div>
          </router-link>

          <router-link class="item" :to="'/user/change/'+types"  v-if="change_status==1">
            <div class="pictrue"><img src="@assets/images/record4.png" /></div>
            <div>转换</div>
          </router-link>
          <router-link class="item" :to="'/user/changecord'"  v-if="change_list_status==1">
            <div class="pictrue"><img src="@assets/images/record4.png" /></div>
            <div>转换记录</div>
          </router-link>

        </div>
      </div>
    </div>


    <div class="sign-record">
      <div class="list" v-if="list.length > 0">
        <div class="item" >

          <div class="listn" v-for="(val, index) in list" :key="index">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ val.category_name }}（{{ val.title }}）</div>
              </div>
              <div style="width:100%;">
                <div class="name line1"></div>
                <div style="color:#999;">{{ val.mark }}</div>
                <div style="width:100%;">
                  <div style="float:left;width:50%;margin-top:0.2rem;">{{ val.add_time }}</div>
                  <div style="float:right;width:50%;text-align:right;" class="num" :class="val.number < 0 ? 'font-color-red-l' : ''">
                    {{ val.number < 0 ? "" : "+" }}{{ val.number }}
                  </div>

                </div>
              </div>

            </div>
          </div>

      </div>

      <div class="shoppingCart">
        <div  style="margin-top:0px;"
              class="noCart"
              v-if="showno === 0"
        >
          <div class="pictrue"><img src="@assets/images/noList.png" /></div>
        </div>
      </div>

    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .font-color-red-l {
    color:red !important;
  }
  .bill-details .nav .item {
    overflow: hidden;
  }
</style>
<script>
    import { getCommissionInfo,getBill } from "../../api/user";
    import Loading from "@components/Loading";
    export default {
        name: "UserBill",
        components: {
            Loading
        },
        props: {},
        data: function() {
            return {
              showno:1,
                types: "",
                where: {
                    page: 1,
                    limit: 20
                },
                account_name:'',
                money:0,
                transfer_status:0,
                extract_status:0,
                recharge_status:0,
                change_status:0,

                transfer_list_status:0,
                extract_list_status:0,
                recharge_list_status:0,
                change_list_status:0,


                moneyType:[],
                list: [],
                loaded: false,
                loading: false
            };
        },
        watch: {
            "$route.params.types": function(newVal) {
                let that = this;
                if (newVal != undefined) {
                    that.types = newVal;
                    that.list = [];
                    that.where.page = 1;
                    that.loaded = false;
                    that.loading = false;
                    that.bill();
                    that.getIndex();
                }

            },
            types: function() {
                this.getIndex();
            }
        },
        mounted: function() {
            let that = this;
            that.types = that.$route.params.types;
            that.bill();
            that.getIndex();
            that.$scroll(that.$refs.container, () => {
            !that.loading && that.getIndex();
        });
        },
        methods: {
          toCommissionList(type){
            this.$router.push({path:'/user/bill/'+type})
          },
            code: function() {
                this.sendCode();
            },
            changeTypes: function(val) {
                if (val != this.types) {
                    this.types = val;
                    this.list = [];
                    this.where.page = 1;
                    this.loaded = false;
                    this.loading = false;
                }
            },
            bill:function(){
              let that = this;
              getBill(that.types).then(
                      res => {
                        that.money = res.data.money;
                        that.transfer_status = res.data.transfer_status;
                        that.extract_status = res.data.extract_status;
                        that.recharge_status = res.data.recharge_status;
                        that.change_status = res.data.change_status;
                        that.account_name = res.data.account_name;

                        that.transfer_list_status = res.data.transfer_list_status;
                        that.extract_list_status = res.data.extract_list_status;
                        that.recharge_list_status = res.data.recharge_list_status;
                        that.change_list_status = res.data.change_list_status;


                      },
                      error => {
                        that.$dialog.message(error.msg);
                      }
              );
            },
            getIndex: function() {
                let that = this;
                if (that.loaded == true || that.loading == true) return;
                that.loading = true;
                getCommissionInfo(that.where, that.types).then(
                    res => {
                        that.loading = false;
                        that.moneyType = res.data.moneyType;
                        that.loaded = res.data.list.length < that.where.limit;
                        that.where.page = that.where.page + 1;
                        that.list.push.apply(that.list, res.data.list);

                      if(that.list.length==0){
                        that.showno=0;
                      }else{
                        that.showno=1;
                      }
                    },
                    error => {
                        that.$dialog.message(error.msg);
                    }
            );
            }
        }
    };
</script>
